import { Controller } from '@hotwired/stimulus';

interface OneTrust {
  InitializeBanner?: () => void;
  LoadBanner?: () => void;
  ToggleInfoDisplay?: () => void;
}

declare global {
  interface Window {
    OneTrust?: OneTrust;
  }
}

export default class extends Controller {
  static afterLoad() {
    window.addEventListener('turbo:load', () => {
      if (!document.querySelector('#onetrust-consent-sdk')) {
        // Re-render and attach the OneTrust banner to DOM
        window.OneTrust?.InitializeBanner?.();
        window.OneTrust?.LoadBanner?.();
      }

      const button = document.querySelector('.optanon-show-settings');
      button?.addEventListener(
        'click',
        () => {
          window.OneTrust?.ToggleInfoDisplay?.();
        },
        { once: true },
      );
    });
  }
}
